var global = require('./_global');
var navigator = global.navigator;

module.exports = navigator && navigator.userAgent || '';



// WEBPACK FOOTER //
// node_modules/_core-js@2.5.6@core-js/modules/_user-agent.js